import {createRouter, createRouterHooks} from '@pexip/router';

export const router = createRouter();
export const {useRouter, createRoutesHook, createSubRoutesHook} =
    createRouterHooks(router);
